import { useI18n } from './I18nContext';

/**
 * Compact variant — a small pill displaying the current locale code that
 * cycles through the available locales on click. Used in the navbar so the
 * locale picker takes about 36px instead of the ~120px the ``<select>``
 * occupies.
 */
function LocaleCycle({ className = '' }) {
  const { locale, setLocale, locales } = useI18n();
  const current = locales.find((l) => l.id === locale) ?? locales[0];
  const next = () => {
    const idx = locales.findIndex((l) => l.id === locale);
    const nextLocale = locales[(idx + 1) % locales.length];
    if (nextLocale) setLocale(nextLocale.id);
  };
  return (
    <button
      type="button"
      onClick={next}
      title={`Language: ${current.label}`}
      aria-label={`Language (currently ${current.label}). Click to change.`}
      className={`inline-flex h-9 min-w-9 items-center justify-center rounded-full px-2 text-xs font-semibold uppercase tracking-wide text-text hover:bg-surfaceAlt hover:text-primary transition ${className}`}
    >
      {String(current.id).slice(0, 2)}
    </button>
  );
}

export default function LocaleSwitcher({ className = '', compact = false }) {
  const { locale, setLocale, locales } = useI18n();

  if (compact) return <LocaleCycle className={className} />;

  return (
    <select
      aria-label="Language"
      value={locale}
      onChange={(e) => setLocale(e.target.value)}
      className={`rounded-full border border-border bg-surface px-3 py-1 text-xs font-semibold text-text focus:outline-none focus:ring-2 focus:ring-primary/30 ${className}`}
    >
      {locales.map((l) => (
        <option key={l.id} value={l.id}>
          {l.label}
        </option>
      ))}
    </select>
  );
}
